export const DateUnit = {
    SECOND: 'second',
    MINUTE: 'minute',
    HOUR: 'hour',
    DAY: 'day',
    MONTH: 'month',
    YEAR: 'year'
};

export class DateUtil {

/**
 * @param {Date} firstDate 
 * @param {Date} secondDate
 * @param {DateUnit} unit
 * @returns {Number} The difference between the two dates in days
 */
  static diff(firstDate, secondDate, unit) {
    const startDate = DateUtil.toDate(firstDate);
    const endDate = DateUtil.toDate(secondDate);
    if (!startDate || !endDate) {
      return null;
    }
    const diffTime = Math.abs(endDate - startDate);
    switch (unit) {
      case DateUnit.SECOND:
        return Math.ceil(diffTime / 1000);
      case DateUnit.MINUTE:
        return Math.ceil(diffTime / (1000 * 60));
      case DateUnit.HOUR:
        return Math.ceil(diffTime / (1000 * 60 * 60));
      case DateUnit.DAY:
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      case DateUnit.MONTH:
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 30));
      case DateUnit.YEAR:
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 365));
      default:
        return null;
    }
  }

  static toDate(date) {
    try {
        if (!date) return null;

        if (date instanceof Date) {
            return isNaN(date.getTime()) ? null : date;
        }

        if (typeof date === 'string') {
            // Safari (desktop e mobile) não parseia corretamente strings sem timezone designator.
            // Formatos problemáticos no Safari:
            //   'YYYY-MM-DD'            → interpretado como UTC (off-by-one em fusos negativos)
            //   'YYYY-MM-DDTHH:mm:ss'   → RangeError: Invalid Date
            //   'YYYY-MM-DD HH:mm:ss'   → RangeError: Invalid Date
            //
            // Solução: usar new Date(year, month, day, ...) que é universalmente suportado.

            // Normaliza separador espaço para 'T'
            const normalized = date.replace(' ', 'T');

            // Date-only: 'YYYY-MM-DD' → construir via componentes numéricos (hora local)
            const dateOnlyMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
            if (dateOnlyMatch) {
                return new Date(
                    parseInt(dateOnlyMatch[1]),
                    parseInt(dateOnlyMatch[2]) - 1,
                    parseInt(dateOnlyMatch[3])
                );
            }

            // DateTime sem timezone: 'YYYY-MM-DDTHH:mm:ss' ou 'YYYY-MM-DDTHH:mm'
            const dateTimeMatch = normalized.match(
                /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/
            );
            if (dateTimeMatch) {
                return new Date(
                    parseInt(dateTimeMatch[1]),
                    parseInt(dateTimeMatch[2]) - 1,
                    parseInt(dateTimeMatch[3]),
                    parseInt(dateTimeMatch[4]),
                    parseInt(dateTimeMatch[5]),
                    parseInt(dateTimeMatch[6] || '0')
                );
            }

            // Strings com timezone (Z, +HH:mm, -HH:mm) ou outros formatos → Date nativo
        }

        const result = new Date(date);
        return isNaN(result.getTime()) ? null : result;
    } catch (error) {
        return null;
    }
  }
  /**
   * @param {Date} date 
   * @param {String} format 
   * @returns String formatted date
   */
  static format(date, format) {
    if (!date) {
      return '';
    }

    const dateObj = DateUtil.toDate(date);
    if (!dateObj) {
      return '';
    }

    const padZero = (value, length = 2) => String(value).padStart(length, '0');
    const map = {
      yyyy: dateObj.getFullYear(),
      yy: dateObj.getFullYear().toString().slice(-2),
      MM: padZero(dateObj.getMonth() + 1),
      dd: padZero(dateObj.getDate()),
      HH: padZero(dateObj.getHours()),
      mm: padZero(dateObj.getMinutes()),
      ss: padZero(dateObj.getSeconds()),
      SSS: padZero(dateObj.getMilliseconds(), 3)
    };
  
    return format.replace(/yyyy|yy|MM|dd|HH|mm|ss|SSS/g, (matched) => map[matched]);
  }
}